import type { CustomContent } from '@/blocks/domain/types';
import { customUsesSections } from '@/blocks/domain/helpers/customSections';
import type { RendererProps } from '../../domain/RendererContract';
import { FieldsBlockRender } from './FieldsBlockRender';
import { customRenderer as proseCustomRenderer } from './ProseRender';

type Props = RendererProps<CustomContent>;

const LegacyCustomRender = proseCustomRenderer.Component;

/**
 * The Custom block (LLAMS-610). Sectioned content draws like a Letterhead's sections (Heading / Text /
 * Label + value elements in columns); legacy `{ title, bodyHtml }` content, still what every saved
 * block, template instance and quote holds until it is re-saved from the editor, keeps drawing as
 * prose with the prose renderer's own slicing and quote / canvas editing.
 */
function CustomRenderImpl(props: Props) {
  const { content, style, context, accentColor, knownPaths } = props;
  if (!customUsesSections(content)) return <LegacyCustomRender {...props} />;

  return (
    <FieldsBlockRender
      fields={content.fields ?? []}
      style={style}
      context={context}
      accentColor={accentColor}
      knownPaths={knownPaths}
      ariaLabel="block-custom"
      sections={content.sections}
    />
  );
}

/** Splittable for the legacy prose path; a sectioned block has no prose rows, so `DocumentRender` never slices it. */
export const renderer = {
  Component: CustomRenderImpl,
  flowBehavior: 'splittable' as const
};

export type { CustomContent };
